import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ToggleButton from "./ToggleButton";

// Provides filter menu .
// Also handles filter menu toggle and click outside to close.
export default function FilterMenu({showTraining, setShowTraining, showEvent, setShowEvent, selectedAthlete, setSelectedAthlete}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const [athletes, setAthletes] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/athletes-list`)
      .then(res => res.json())
      .then(data => setAthletes(data))
      .catch(console.error);
  }, []);

  
  useEffect(() => {
    const handleClickOutside = (e) => {
      alert("see if clicked outside filter menu...");
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        alert("clicked outside filter menu, closing menu");
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  // Helper to build href for dynamic content pages
  const makeHref = (item) => item.url || `/content/${item.code}`;

  const isActive = (target) => path === target ? "active-link" : "";
  return (
    <>
      <div className="filter-menu" id="filterMenu">
        <button
          className="menu-close"
          onClick={() => toggleFilterMenu()}
          aria-label="Close menu"
        >
          ×
        </button>
        <label>Atleten:</label>
        <select value={selectedAthlete} onChange={e => setSelectedAthlete(e.target.value)}>
          <option value="all">Alle atleten</option>
          {athletes.map(item => (
            <option key={`filter-menu-athlete-${item.code}`} value={item.code}>
              {item.name}
            </option>
          ))}
        </select>
        <label>Evenement tonen:</label>
        <ToggleButton
          label="Evenement tonen"
          checked={showEvent}
          onChange={setShowEvent}
        />
        <label>Trainingen tonen:</label>
        <ToggleButton
          label="Trainingen tonen"
          checked={showTraining}
          onChange={setShowTraining}
        />
      </div>
    </>
  );
}